function SkeletonLoader() {
  return (
    <div className="bg-background px-6 py-4 md:py-8 w-full">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* <div className="h-12 w-64 bg-gray-300 rounded-lg animate-pulse mb-8" /> */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="space-y-3">
              <div className="h-48 bg-gray-300 rounded-lg animate-pulse" />
              <div className="h-4 bg-gray-300 rounded animate-pulse" />
              <div className="h-4 bg-gray-300 rounded animate-pulse w-3/4" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SkeletonLoader;
